import PropTypes from "prop-types"
import React from "react"

import TextCollapsible from "src/components/TextCollapsible"

const JobLineItemNoteSubRow = ({ notes, productName, onClick }) => {
  // The TextCollapsible "show more" / "show less" button is itself a
  // <button>; ignore parent-row clicks that originated inside one so
  // toggling the clamp doesn't also open the edit modal.
  const handleClick = (event) => {
    if (event.target.closest("button")) return
    onClick()
  }

  const handleKeyDown = (event) => {
    if (event.target.closest("button")) return
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      onClick()
    }
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label={`Edit note for ${productName}`}
      className="cursor-pointer border-l-2 border-gray-300 pl-2.5 text-sm italic text-gray-600 hover:text-gray-800"
    >
      <TextCollapsible lines={2}>{notes}</TextCollapsible>
    </div>
  )
}

JobLineItemNoteSubRow.propTypes = {
  notes: PropTypes.string.isRequired,
  productName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

export default JobLineItemNoteSubRow
